export default "__VITE_ASSET__BFLZl3hE__"